export const EMPTY_MESSAGE_ID = 'empty.message';
export const ONLY_VALUE_MESSAGE_ID = 'only.value.message';